import { email_validation_api } from '@axo/shared/data-access/api';
import { DataAccessContext } from '@axo/shared/data-access/provider';
import { debounceFunction } from '@axo/shared/util/fp';
import { useContext, useEffect, useMemo, useState } from 'react';

type UseEmailValidationServiceParams = {
  email?: string;
};

export function useEmailValidationService({
  email,
}: UseEmailValidationServiceParams) {
  const {
    url: { api },
  } = useContext(DataAccessContext);

  const [isValid, setIsValid] = useState<boolean | undefined>(true);

  const validateEmail = useMemo(
    () =>
      debounceFunction(async (value: string) => {
        if (!value) {
          setIsValid(true);
          return;
        }

        const { IsValid: _isValid } = await email_validation_api.validateEmail(
          api,
          value,
        );

        setIsValid(_isValid);
      }, 500),
    [api],
  );

  useEffect(() => {
    validateEmail(email ?? '');
  }, [email, validateEmail]);

  return isValid;
}
